export const ENGLISH = 'en';
export const CHINESE = 'zh-cn';
